import React from "react";
//components & containers
// import Banner from "../presentational_components/navBar";
import AppWrapper from "../presentational_components/wrapper";
import VerticalStepper from "./steppers.js";
import {withRouter} from "react-router-dom";
import {Content} from "../styles/App_styles.js";
//== material ui components
import {CssBaseline} from "@material-ui/core";

function App() {
  let props = {name: "Rotom Demo", pub_ancor: "https://dl.acm.org/doi/abs/10.1145/3448016.3457258", blog_link: "https://megagon.ai/blog/rotom-a-meta-learned-data-augmentation-framework-for-entity-matching-data-cleaning-text-classification-and-beyond/"}

  return (
    <>
      <CssBaseline />
      <AppWrapper props={props} >
      <Content>
        <VerticalStepper />
      </Content>
      </AppWrapper>
    </>
  );
}

export default withRouter(App);
